import { IOrderTableViewListVM } from '../../models/response/IOrderTableViewResponse';
const initialOrderTableViewState: IOrderTableViewListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  OrderTableViews: [],
};

export default initialOrderTableViewState;
